export default {
  // Common
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    loading: 'Loading...',
    noData: 'No Data',
    operation: 'Operation',
    status: 'Status',
    sort: 'Sort',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    actions: 'Actions',
    enable: 'Enable',
    disable: 'Disable',
    active: 'Active',
    inactive: 'Inactive'
  },
  
  // Navigation
  nav: {
    dashboard: 'Dashboard',
    products: 'Products',
    productList: 'Product List',
    categories: 'Categories',
    company: 'Company Info',
    cases: 'Client Cases',
    caseStudies: 'Case Studies',
    faq: 'FAQ',
    advantages: 'Core Advantages',
    process: 'Service Process',
    inquiries: 'Inquiries',
    siteConfig: 'Site Config',
    translations: 'Translations'
  },
  
  // Login
  login: {
    title: 'CMS Management System',
    username: 'Username',
    password: 'Password',
    loginBtn: 'Login',
    logout: 'Logout',
    usernamePlaceholder: 'Please enter username',
    passwordPlaceholder: 'Please enter password',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password?',
    tips: 'Tips',
    success: 'Login successful',
    error: 'Login failed, please check username and password'
  },
  
  // Dashboard
  dashboard: {
    title: 'Welcome to CMS Management System',
    subtitle: 'Enterprise Website Content Management System',
    totalProducts: 'Total Products',
    totalCases: 'Total Cases',
    totalInquiries: 'Total Inquiries',
    systemStatus: 'System Status',
    quickAccess: 'Quick Access',
    recentActivity: 'Recent Activity'
  },
  
  // Product
  product: {
    listTitle: 'Product List',
    createTitle: 'Add Product',
    editTitle: 'Edit Product',
    productId: 'Product ID',
    name: 'Product Name',
    shortName: 'Short Name',
    category: 'Category',
    description: 'Description',
    price: 'Price',
    priceUnit: 'Price Unit',
    imageUrl: 'Main Image',
    badge: 'Badge',
    demoUrl: 'Demo URL',
    features: 'Features',
    highlights: 'Highlights',
    techStack: 'Tech Stack',
    screenshots: 'Screenshots',
    status: 'Status',
    allCategories: 'All Categories',
    addFeature: 'Add Feature',
    addHighlight: 'Add Highlight',
    addTech: 'Add Technology',
    addScreenshot: 'Add Screenshot',
    uploadImage: 'Upload Image',
    selectCategory: 'Select Category'
  },
  
  // Category
  category: {
    categoryId: 'Category ID',
    name: 'Category Name',
    icon: 'Icon',
    sortOrder: 'Sort Order',
    status: 'Status'
  },
  
  // Company
  company: {
    name: 'Company Name',
    englishName: 'English Name',
    slogan: 'Slogan',
    description: 'Description',
    founded: 'Founded',
    employees: 'Employees',
    clients: 'Clients',
    projects: 'Projects',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    workHours: 'Work Hours',
    wechatLink: 'WeChat Link',
    weiboLink: 'Weibo Link',
    linkedinLink: 'LinkedIn Link'
  },
  
  // Client Case
  clientCase: {
    name: 'Client Name',
    industry: 'Industry',
    systemType: 'System Type',
    logoIcon: 'Logo Icon',
    description: 'Description',
    results: 'Results',
    sortOrder: 'Sort Order',
    addResult: 'Add Result'
  },
  
  // Case Study
  caseStudy: {
    caseId: 'Case ID',
    title: 'Title',
    subtitle: 'Subtitle',
    clientName: 'Client Name',
    industry: 'Industry',
    coverImage: 'Cover Image',
    images: 'Images',
    challenge: 'Challenge',
    solution: 'Solution',
    results: 'Results',
    resultTags: 'Result Tags',
    addImage: 'Add Image',
    addTag: 'Add Tag'
  },
  
  // FAQ
  faq: {
    question: 'Question',
    answer: 'Answer',
    sortOrder: 'Sort Order',
    addQuestion: 'Add Question'
  },
  
  // Advantage
  advantage: {
    icon: 'Icon',
    title: 'Title',
    description: 'Description',
    sortOrder: 'Sort Order'
  },
  
  // Process
  process: {
    stepNumber: 'Step Number',
    title: 'Title',
    description: 'Description',
    icon: 'Icon'
  },
  
  // Site Config
  siteConfig: {
    siteName: 'Site Name',
    siteTitle: 'Site Title',
    keywords: 'Keywords',
    description: 'Description',
    copyright: 'Copyright',
    icpLicense: 'ICP License',
    publicSecurityLicense: 'Public Security License',
    seoConfig: 'SEO Config',
    basicConfig: 'Basic Config',
    contactConfig: 'Contact Config',
    socialLinks: 'Social Links'
  },
  
  // Inquiry
  inquiry: {
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    company: 'Company',
    content: 'Content',
    status: 'Status',
    handleStatus: 'Handle Status',
    handled: 'Handled',
    unhandled: 'Unhandled',
    contactTime: 'Contact Time',
    remark: 'Remark'
  },
  
  // Messages
  message: {
    confirmDelete: 'Are you sure you want to delete?',
    deleteSuccess: 'Deleted successfully',
    saveSuccess: 'Saved successfully',
    updateSuccess: 'Updated successfully',
    createSuccess: 'Created successfully',
    operationFailed: 'Operation failed',
    dataNotExist: 'Data does not exist',
    pleaseSelect: 'Please select',
    inputRequired: 'Please enter',
    uploadSuccess: 'Uploaded successfully',
    uploadFailed: 'Upload failed',
    fileSizeLimit: 'File size cannot exceed',
    fileTypeLimit: 'Only image formats are supported',
    networkError: 'Network error, please try again later'
  },
  
  // Validation
  validation: {
    required: '{field} is required',
    minLength: '{field} must be at least {min} characters',
    maxLength: '{field} cannot exceed {max} characters',
    email: 'Please enter a valid email address',
    phone: 'Please enter a valid phone number',
    url: 'Please enter a valid URL',
    number: 'Please enter a number',
    pattern: 'Invalid format'
  },
  
  // Language
  language: {
    switcher: 'Language',
    zhCN: '简体中文',
    zhTW: '繁體中文',
    en: 'English',
    ru: 'Русский'
  }
}
